import React from 'react'
import { Tooltip } from 'antd'

import { useMusicOptions } from './_hooks/menu-options'
import OptionDropdown from './OptionDropdown'

import type { UseMusicOptionsConfig } from './_hooks/menu-options'
import type { MusicOptionKey } from './_types'

import StyledButton from '@/pages/tad.ai/_components/StyledButton'

import { useState } from 'react';
import { cls } from 'tagged-classnames-free';
import { CssIcon } from '@/components/CssIcon';
export type MusicOption =
  | MusicOptionKey
  | {
      key: MusicOptionKey
      /** 是否仅渲染 icon 默认 false */
      iconOnly?: boolean
    }
export interface MusicOptionsProps extends UseMusicOptionsConfig {
  expand?: MusicOption[]
  onlyExpand?: boolean
  className?: string
  iconClassName?: string
  btnClassName?: string
  dropdownHidden?: MusicOptionKey[]
  error?: {
    allowRetry: boolean
    onRetry: () => Promise<void>
    message: string
  }
}

const MusicOptions: React.FC<MusicOptionsProps> = (props) => {
  const {
    expand: _expand,
    onlyExpand = false,
    hidden,
    data,
    error,
    onDeleted,
    className,
    iconClassName,
    btnClassName,
    dropdownHidden,
    onSelect,
  } = props

  const [retryLoading, setRetryLoading] = useState(false)
  const [menuDropdownOpen, setMenuDropdownOpen] = useState(false)
  const options = useMusicOptions({
    hidden,
    data,
    onDeleted,
    onSelect,
  })

  const expand = _expand?.map((item) => {
    if (typeof item === 'string') {
      return {
        key: item,
        iconOnly: false,
      }
    }
    return { ...item, iconOnly: item.iconOnly ?? false }
  })

  const dropdownOptions = options.filter((item) => {
    return (
      item.key !== 'liked' &&
      item.key !== 'select' &&
      !dropdownHidden?.includes(item.key as MusicOptionKey)
    )
  })

  return (
    <div
      className={cls`text-f-text-quaternary flex items-center gap-1 md:gap-3 ${className}`}
    >
      {/* 生成失败的歌曲，点击"Try again"可以重试生成该歌曲（前端先隐藏重试按钮，产品后续再优化重试功能）
      {error && (
        <button
          onClick={async () => {
            if (!error.allowRetry) {
              message.error(error.message)
              return
            }
            if (retryLoading) {
              return
            }
            setRetryLoading(true)
            try {
              await error.onRetry()
            } catch (error) {
              // ignore
            } finally {
              setRetryLoading(false)
            }
          }}
          type='button'
          className={cls`
            bg-f-primary-style-2 inline-flex w-fit items-center gap-1 rounded-xl px-2 py-1 text-xs
            ${error.allowRetry ? 'text-f-primary hover:text-f-primary-hover' : 'text-f-text-disabled'}
          `}
        >
          {retryLoading && <Spin size='small' spinning={retryLoading} />}
          {!retryLoading && <Trans>Try again</Trans>}
        </button>
      )} */}
      {expand?.map((expandItem) => {
        const target = options.find((item) => item.key === expandItem.key)

        if (!target) {
          return null
        }

        const renderButton = (dropdownOpen = false) => {
          const button = expandItem.iconOnly ? (
            <button
              key={target.key}
              type='button'
              className={cls`
                text-f-text-quaternary hover:bg-f-bg-hover hover:text-f-text-secondary inline-flex size-6
                cursor-pointer items-center justify-center rounded border-0 bg-transparent p-0
                ${dropdownOpen && 'bg-f-bg-hover text-f-text-secondary'}
              `}
              onClick={
                target.children
                  ? (event) => {
                      event.stopPropagation()
                    }
                  : (event) => {
                      event.stopPropagation()

                      target.onClick?.()
                    }
              }
            >
              {typeof target.icon === 'string' ? (
                <CssIcon
                  className={cls`size-5 ${target.icon} ${iconClassName}`}
                />
              ) : (
                target.icon
              )}
            </button>
          ) : (
            <StyledButton
              key={target.key}
              size='small'
              onClick={(event) => {
                event.stopPropagation()

                target.onClick?.()
              }}
              className={cls`group/options text-xs ${target.btnClassName} ${btnClassName}`}
            >
              {target.icon && typeof target.icon === 'string' ? (
                <CssIcon
                  className={cls`size-5 ${target.icon} ${iconClassName}`}
                />
              ) : (
                target.icon
              )}
              <span>{target.label}</span>
            </StyledButton>
          )

          return target.key === 'download' ? (
            <Tooltip
              key={target.key}
              title={target.label}
              arrow={false}
              classNames={{
                body: 'text-xs !min-h-0',
                root: 'border border-f-border-active rounded-lg',
              }}
            >
              <span className='inline-flex'>{button}</span>
            </Tooltip>
          ) : (
            button
          )
        }

        if (target.children) {
          return (
            <OptionDropdown key={target.key} items={target.children}>
              {(open) => renderButton(open)}
            </OptionDropdown>
          )
        }
        return renderButton()
      })}
      {!onlyExpand && dropdownOptions.length > 0 && (
        <OptionDropdown
          items={dropdownOptions}
          afterOpenChange={setMenuDropdownOpen}
        >
          <CssIcon
            className={cls`i-cus--tad-more size-5`}
            containerClassName={cls`
              hover:bg-f-bg-hover hover:text-f-text-secondary size-6 cursor-pointer
              rounded ${menuDropdownOpen && 'bg-f-bg-hover text-f-text-secondary'}
            `}
            containerProps={{
              onClick: (event) => {
                event.stopPropagation()
              },
            }}
          />
        </OptionDropdown>
      )}
    </div>
  )
}

export default MusicOptions
